var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-records-yet"},[_c('div',{staticClass:"no-records-yet__icon"},[_c('v-icon',{attrs:{"x-large":"","color":"#6a4bc0"}},[_vm._v("mdi-pound")])],1),_c('div',{staticClass:"no-records-yet__desc"},[_vm._v(" "+_vm._s(_vm.$t('shared.noRecordsYet.noRecordsYet'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }